// extracted by mini-css-extract-plugin
export var videoWrapperStyle = "section_large_video_player-module--videoWrapperStyle--+HSms";